import { render } from "./splashscreen.vue?vue&type=template&id=2c775478"
import script from "./splashscreen.vue?vue&type=script&lang=js"
export * from "./splashscreen.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__